import { render, staticRenderFns } from "./CreateRequisitesGroupDlg.vue?vue&type=template&id=4be6dabe&"
import script from "./CreateRequisitesGroupDlg.vue?vue&type=script&lang=js&"
export * from "./CreateRequisitesGroupDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports